import { useEffect, useMemo, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, Pencil, Trash2 } from "lucide-react";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";

export default function AdminCategoryPage() {
  const { isAdmin } = useAuth();
  const { id } = useParams();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [status, setStatus] = useState("");

  const category = useMemo(() => categories.find((item) => item.id === id), [categories, id]);

  const refresh = async () => {
    const [categoryResponse, productResponse] = await Promise.all([
      api.get("/categories"),
      api.get(`/categories/${id}/products`),
    ]);
    setCategories(categoryResponse.data);
    setProducts(productResponse.data);
  };

  useEffect(() => { if (isAdmin) refresh(); }, [id, isAdmin]);

  if (!isAdmin) return <Navigate to="/produkte" replace />;

  const deleteProduct = async (productId, productTitle) => {
    const confirmed = window.confirm(`Möchten Sie „${productTitle}“ wirklich löschen?`);
    if (!confirmed) return;
    await api.delete(`/admin/products/${productId}`);
    setStatus(`„${productTitle}“ wurde gelöscht.`);
    refresh();
  };

  return <main className="page" data-testid="admin-category-page">
    <Link to="/admin" className="back-link" data-testid="admin-category-back-link"><ArrowLeft size={17} /> Admin</Link>
    <section className="detail-head"><div><span data-testid="admin-category-status">Maschine</span><h1 data-testid="admin-category-title">{category?.name || "Maschine"}</h1><p data-testid="admin-category-summary">{[category?.machine_number && `Nr. ${category.machine_number}`, category?.year && `Baujahr ${category.year}`].filter(Boolean).join(" · ") || "Bauteile bearbeiten oder direkt löschen."}</p></div></section>
    {status && <div className="status-line" data-testid="admin-category-status-message">{status}</div>}
    <section className="admin-table" data-testid="admin-category-products-table">
      {products.length === 0 && <div className="admin-row" data-testid="admin-category-products-empty">Keine Bauteile in dieser Maschine.</div>}
      {products.map((product) => <div className="admin-row category-product-row" key={product.id} data-testid={`admin-category-product-row-${product.id}`}>
        <div className="category-product-copy"><strong data-testid={`admin-category-product-title-${product.id}`}>{product.title}</strong><span data-testid={`admin-category-product-count-${product.id}`}>{product.part_count} Bauteile</span></div>
        <div className="order-actions" data-testid={`admin-category-product-actions-${product.id}`}>
          <Link className="small-pill-action" to={`/admin/produkte/${product.id}`} data-testid={`admin-category-product-edit-${product.id}`}><Pencil size={14} /> Bearbeiten</Link>
          <button className="danger-action" onClick={() => deleteProduct(product.id, product.title)} data-testid={`admin-category-product-delete-${product.id}`}><Trash2 size={14} /> Löschen</button>
        </div>
      </div>)}
    </section>
  </main>;
}